<template>
	<div
		class="inline-block animate-spin rounded-full border-2 border-solid border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
		:class="[size, classes, color]"
		role="status"
	/>
</template>

<script setup>
const props = defineProps({
	size: {
		type: String,
		default: 'h-5 w-5'
	},
	color: {
		type: String,
		default: 'border-won-green'
	},
	classes: {
		type: String,
		default: ''
	}
});
</script>
